import FJVirtualizedMixView from '../../../common/components/FJVirtualizedMixView/FJVirtualizedMixView';
import PropTypes from 'prop-types';
import NoContentIcon from '../../../assets/svg/no-content.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJHistoryPanel.module.less';
import { useRef, useMemo, useEffect, useState, useCallback } from 'react';
import FJBlankPanel from '../FJBlankPanel/FJBlankPanel';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJSourcePreviewItem from '../FJSourcePreviewItem/FJSourcePreviewItem';
import classNames from 'classnames';

const MAX_IMAGE_WIDTH = 500;
const MIN_IMAGE_WIDTH = 307;
const IMAGE_SPACE = 14;
const MIN_IMAGE_ROW_NUM = 2;
const FJHistoryPanel = props => {
    const {
        appType,
        list,
        selectList,
        setSliceSelectList,
        onDownload,
        onAddToMedia,
        onDelete,
        reGenerate,
        previewImage,
        active,
        historyListLoadStatus = FJConstant.SUCCESS,
        onEdit,
        headerChildren,
        reallyHistoryListLength,
        isShowAddToMediaButton,
        onApplyMedia,
        isApplyButton = false,
        onReload,
        isShowAddToEditPageButton = false,
        onAddToEditPage,
        retryLoadingIds = [],
        className,
        listTotal,
        isImageList,
        getData,
        onPrivacySettingChange,
        searchText,
    } = props;
    const contentRef = useRef(null);
    const [imgWidth, setImgWidth] = useState(450);
    const [imgRowNum, setImgRowNum] = useState(3);
    useEffect(() => {
        const _updateUI = FJUtil.debounce(() => {
            if (contentRef.current) {
                const maxWidth = contentRef.current._view.offsetWidth;
                if (!maxWidth) return;
                const rowNum = Math.max(Math.ceil(maxWidth / (IMAGE_SPACE + MAX_IMAGE_WIDTH)), MIN_IMAGE_ROW_NUM);
                const imgW = Math.floor(
                    Math.max(maxWidth / rowNum - IMAGE_SPACE, MIN_IMAGE_WIDTH) + IMAGE_SPACE / rowNum,
                );
                setImgRowNum(rowNum);
                setImgWidth(imgW);
                setTimeout(() => {
                    contentRef.current?.init && contentRef.current.init();
                }, 200);
            }
        }, 200);
        _updateUI();
        window.addEventListener('resize', _updateUI);
        return () => {
            window.removeEventListener('resize', _updateUI);
        };
    }, [list, active]);

    const onSelected = (id, bool) => {
        //暂时不加，以后会加
        // if (e.shiftKey) {
        //     let newList = [...selectList, id];
        //     const startIndex = list.findIndex(i => newList.includes(i.id));
        //     const endIndex = list.findLastIndex(i => i.id === id);

        //     newList = list.slice(startIndex, endIndex + 1).map(i => i.id);
        //     setSliceSelectList(newList);
        // } else
        if (bool) {
            setSliceSelectList([...selectList, id]);
        } else {
            setSliceSelectList(selectList.filter(i => i !== id));
        }
    };
    const isShowSelected = useMemo(() => {
        return selectList?.length > 0;
    }, [selectList]);

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                setSliceSelectList([]);
            }
        },
        [setSliceSelectList],
    );
    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
        //TODO 业务需要此依赖
    }, [_keyDown, isShowSelected]);
    const _preview = data => {
        if (selectList.length) {
            onSelected(data.id, !selectList.includes(data.id));
        } else if (appType !== FJAppConstant.FAKE_3D) {
            previewImage(data);
        }
    };

    /**
     * @desc 获得模板size的列表
     * @param list - 模板的数据列表
     * @return {*[]}
     * @private
     */
    const _getSizeList = () => {
        if (!list || list.length === 0) return [];
        let items = [];
        for (let i = 0; i < list.length; i++) {
            let data = list[i];
            let radio = 1;
            if (data.width) {
                radio = parseFloat(data.width / data.height);
            } else if (data.ratio) {
                radio = data.ratio;
            }

            let height = imgWidth / radio;
            items.push({ width: imgWidth, height: height });
        }
        return items;
    };

    const _renderItem = (itemRect, item) => {
        if (!item) return null;
        const selected = !!selectList?.find(id => id === item.id);
        return (
            <div
                // 会有两个相同id同时渲染的情况
                key={item.type + item.id}
                style={{
                    position: 'absolute',
                    left: itemRect.left,
                    top: itemRect.top,
                    width: itemRect.width,
                    height: itemRect.height,
                }}
            >
                <FJSourcePreviewItem
                    appType={appType}
                    onPrivacySettingChange={onPrivacySettingChange}
                    item={item}
                    selected={selected}
                    onSelected={onSelected}
                    isShowSelected={isShowSelected}
                    onAddToMedia={onAddToMedia}
                    onDelete={onDelete}
                    onDownload={onDownload}
                    reGenerate={reGenerate}
                    isShowAddToMediaButton={isShowAddToMediaButton}
                    onApplyMedia={onApplyMedia}
                    isApplyButton={isApplyButton}
                    isShowAddToEditPageButton={isShowAddToEditPageButton}
                    onAddToEditPage={onAddToEditPage}
                    onReload={onReload}
                    isTransparentBG={
                        appType === FJAppConstant.VIDEO_REMOVE_BG || appType === FJAppConstant.PHOTO_REMOVE_BG
                    }
                    onClick={_preview}
                    hideDownload={
                        appType === FJAppConstant.FAKE_3D ||
                        (appType === FJAppConstant.AI_VIDEO_GENERATOR && item.status !== 'completed')
                    }
                    hideDelete={
                        appType === FJAppConstant.AI_VIDEO_GENERATOR &&
                        item.status === 'progress' &&
                        item.status === 'waiting'
                    }
                    onEdit={onEdit}
                    hideEdit={
                        (appType !== FJAppConstant.FAKE_3D &&
                            appType !== FJAppConstant.PHOTO_REMOVE_BG &&
                            appType !== FJAppConstant.VIDEO_REMOVE_BG) ||
                        (appType === FJAppConstant.AI_VIDEO_GENERATOR && item.status === 'progress')
                    }
                    retryLoadingIds={retryLoadingIds}
                />
            </div>
        );
    };
    return (
        <div className={classNames(styles.content, className)} style={{ display: active ? 'block' : 'none' }}>
            {headerChildren}
            {historyListLoadStatus === FJConstant.LOADING && ((isImageList && list?.length === 0) || !isImageList) ? (
                <div className={styles.loading}>
                    <FJLoading strokeColor='#686c7e' />
                </div>
            ) : (
                <>
                    {reallyHistoryListLength ? (
                        <>
                            {list?.length ? (
                                <FJVirtualizedMixView
                                    className={classNames(styles.img_list_box, {
                                        [styles.ai_video_generator_list_box]:
                                            appType === FJAppConstant.AI_VIDEO_GENERATOR,
                                    })}
                                    list={list || []}
                                    row={imgRowNum}
                                    childrenSizeList={_getSizeList(list)}
                                    rowSpace={IMAGE_SPACE}
                                    verticalSpace={IMAGE_SPACE}
                                    renderItem={_renderItem}
                                    ref={contentRef}
                                    getData={getData}
                                >
                                    {isImageList && (
                                        <>
                                            {listTotal === list.length ? (
                                                <div className={styles.end_box}>
                                                    <div className={styles.end_text}>
                                                        {FJLocalStore._('scroll-end-tip')}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={styles.loading_box}>
                                                    <FJLoading
                                                        strokeColor='#a8acbc'
                                                        style={{ width: 30, height: 30 }}
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}
                                </FJVirtualizedMixView>
                            ) : (
                                <FJBlankPanel
                                    icon={<NoContentIcon />}
                                    text={FJLocalStore._('sorry-no-matches-founded')}
                                />
                            )}
                        </>
                    ) : (
                        <FJBlankPanel
                            icon={<NoContentIcon />}
                            text={
                                searchText
                                    ? FJLocalStore._('search-fonts-error').replace('xxx', ' "' + searchText + '"')
                                    : FJLocalStore._('no-history-yet')
                            }
                        />
                    )}
                </>
            )}
        </div>
    );
};
FJHistoryPanel.propTypes = {
    appType: PropTypes.string,
    list: PropTypes.array,
    type: PropTypes.string,
    selectList: PropTypes.array,
    setSliceSelectList: PropTypes.func,
    onDownload: PropTypes.func,
    onDelete: PropTypes.func,
    reGenerate: PropTypes.func,
    previewImage: PropTypes.func,
    active: PropTypes.bool,
    historyListLoadStatus: PropTypes.string,
    onEdit: PropTypes.func,
    headerChildren: PropTypes.node,
    reallyHistoryListLength: PropTypes.number,
    isShowAddToMediaButton: PropTypes.bool,
    onAddToMedia: PropTypes.func,
    onApplyMedia: PropTypes.func,
    isApplyButton: PropTypes.bool,
    onReload: PropTypes.func,
    isShowAddToEditPageButton: PropTypes.bool,
    onAddToEditPage: PropTypes.func,
    retryLoadingIds: PropTypes.array,
    className: PropTypes.string,
    listTotal: PropTypes.number,
    isImageList: PropTypes.bool,
    getData: PropTypes.func,
    onPrivacySettingChange: PropTypes.func,
};
export default FJHistoryPanel;
